module.exports = __webpack_public_path__ + "img/slide-3.be3e280b.webp";